export const MENU_ITEM_MODAL_SET_DATE = 'MENU_ITEM_MODAL_SET_DATE';
export const MENU_ITEM_MODAL_SET_MENU_ITEM_ID = 'MENU_ITEM_MODAL_SET_MENU_ITEM_ID';
export const MENU_ITEM_MODAL_SET_EXISTING_ORDER = 'MENU_ITEM_MODAL_SET_EXISTING_ORDER';
export const MENU_ITEM_MODAL_SET_PRODUCT_ID = 'MENU_ITEM_MODAL_SET_PRODUCT_ID';
export const MENU_ITEM_MODAL_SET_MENU_TYPE_ID = 'MENU_ITEM_MODAL_SET_MENU_TYPE_ID';
export const MENU_ITEM_MODAL_SET_ORDER_ITEMS = 'MENU_ITEM_MODAL_SET_ORDER_ITEMS';
export const MENU_ITEM_MODAL_SET_SHOW_MENU_ITEM_MODAL = 'MENU_ITEM_MODAL_SET_SHOW_MENU_ITEM_MODAL';
export const MENU_ITEM_MODAL_SET_SELECTED_FOOD_GROUP_OPTONS = 'MENU_ITEM_MODAL_SET_SELECTED_FOOD_GROUP_OPTONS';
export const MENU_ITEM_MODAL_SET_PICKUP_LOCATION = 'MENU_ITEM_MODAL_SET_PICKUP_LOCATION';
